import * as React from "react";
import { TextField } from "@mui/material";
import { styled } from "@mui/material/styles";

type ShowWorkflowStateProps = {
  label: string;
  value: string;
  helperText?: string;
  customWidth?: number;
  hidden?: boolean;
};

// Campo de solo lectura: el borde se oculta con `transparent` y no
// pintandolo del color del fondo. Pintarlo de blanco funcionaba unicamente
// sobre fondo blanco; en modo oscuro dibujaba lineas blancas.
const CustomTextField = styled(TextField)`
   & label.Mui-focused {
     border-color: transparent
   },
   & .MuiInput-underline:after {
     border-color: transparent
   },
   & .MuiOutlinedInput-root {
     & fieldset {
       border-color: transparent
     },
     &:hover fieldset {
       border-color: transparent
     },
     &.Mui-focused fieldset {
       border-color: transparent
     },
   },
` as typeof TextField;

export const ShowWorkflowState: React.FC<ShowWorkflowStateProps> = ({
  label,
  value,
  helperText = "",
  customWidth = 500,
  hidden = false,
}) => {
  if (hidden) return null;
  return (
    <CustomTextField
      size={"small"}
      inputProps={{ readOnly: true }}
      variant={"outlined"}
      helperText={helperText}
      sx={{ m: 1, mb: 1.5, width: customWidth }}
      label={label}
      value={value}
    />
  );
};
